export const getDynFlowVarIntro = () => {
  return (
    <>
      Post-Request Variables are created after a REST request, based on the
      response data (e.g., status codes, response body). These variables can be
      used in later actions, and are accessible using Mustache syntax:
      &#123;&#123; my_var_name &#125;&#125;. You can assign them using a JSON
      path or a fixed value. The variable can either APPEND (add to existing
      value) or SET (replace previous value), depending on how you want to
      handle it.
    </>
  );
};
